function getDefaultState() {
  const timezoneOverwrite = localStorage.getItem("timezoneOverwrite")
  return {
    timezoneOverwrite: !timezoneOverwrite || timezoneOverwrite === "undefined" ? undefined : timezoneOverwrite
  }
}

const state = getDefaultState()

const getters = {
  timezoneOverwrite(state) {
    return state.timezoneOverwrite
  }
}

const actions = {
  async overwriteTimezone({ commit }, newTimezone) {
    commit("setTimezone", { newTimezone })
  },
  async resetTimezone({ commit }) {
    commit("setTimezone", { newTimezone: undefined })
  }
}

const mutations = {
  setTimezone(state, { newTimezone }) {
    state.timezoneOverwrite = newTimezone
    if (!newTimezone) localStorage.removeItem("timezoneOverwrite")
    else localStorage.setItem("timezoneOverwrite", newTimezone)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
